document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll(".js-onclick-outside").forEach(item => {
    window.addEventListener("click", () => {
      if (item.dataset.classRemove) {
        item.classList.remove(item.dataset.classRemove)
      }
    })
  })
})
